/**
 * The search result from an OData API call
 */
export interface ODataSearchResult<T> {
    /**
     * The total number of records found in the query
     */
    totalRecords: number;
    /**
     * The total number of records returned in this result
     */
    recordsReturn: number;
    /**
     * The records returned in this result
     */
    records: T[];
}

/**
 * The OData search query object
 */
export interface ODataSearch {
    /**
     * Paging Configuration
     */
    pageInfo: ODataPageInfo;

    /**
     * Filter configuration
     */
    filters: ODataFilter[];

    /**
     * Sort configuration
     */
    sort: ODataSort;
}

/**
 * The current state of an executed OData query
 */
export interface ODataSearchState<T> {
    /**
     * The search query
     */
    oDataSearch: ODataSearch;

    /**
     * The current search result
     */
    searchResults: ODataSearchResult<T>;

    /**
     * If the stat has results
     */
    hasResults?: boolean;

    /**
     * If the state is loading/waiting for an API call
     */
    isLoading?: boolean;
}

/**
 * Pagination information
 */
export interface ODataPageInfo {
    /**
     * Number of results per page
     */
    resultsPerPage: number;

    /**
     * The current page
     */
    currentPage: number;
}

/**
 * A filter for an OData query
 */
export interface ODataFilter {
    /**
     * The key of the filter
     */
    key: string;
    /**
     * The filter value
     */
    value: string;
}

/**
 * ODota sort
 */
export interface ODataSort {
    /**
     * Direction of the sort
     */
    sortDirection: ODataSortDirection;
    /**
     * The field the OData query should be sorted by
     */
    sortField: string;
}

/**
 * The direction of a sort in an odata query
 */
export enum ODataSortDirection {
    Descending = 'desc',
    Ascending = 'asc'
}

export const defaultResultsPerPage = 10;
